import Metadata from "./Metadata";

/**
 * Sentinel used in list-filter definitions to match entities connected to the
 * organisation directly (no subsidiary). Never a valid subsidiary id.
 */
export const NO_SUBSIDIARY = "__no_subsidiary__";

export interface SubsidiaryAddress {
	address1?: string;
	careOf?: string;
	postalCode?: string;
	city?: string;
}

/**
 * A subsidiary (dotterbolag) of the organisation. Its identity, recruitmentContract
 * and pools override the parent organisation's values (per-field fall-through).
 */
export default interface Subsidiary {
	id: string;
	organisation: { id: string };
	name: string;
	orgNo?: string;
	address?: SubsidiaryAddress;
	cfar?: string;
	recruitmentContract?: string;
	pools?: string[];
	metadata?: Metadata;
}

export interface CreateSubsidiaryRequest {
	name: string;
	orgNo?: string;
	address?: SubsidiaryAddress;
	cfar?: string;
	recruitmentContract?: string;
	pools?: string[];
}

export type UpdateSubsidiaryRequest = Partial<CreateSubsidiaryRequest>;
